import { createContext } from 'react';
import { layoutConfig } from 'utils/layout';

export interface RoomLayoutValuesContextState {
  roomWidth: number;
  roomHeight: number; // [?]
  contentHeight: number; // [?]
  tilesWidth: number;
  tilesHeight: number; // [?]
  verticalLayout: boolean;
  contentWidth: number;
  minContentWidth: number;
}

export const RoomLayoutValuesContext = createContext<RoomLayoutValuesContextState>({
  roomWidth: window.innerWidth,
  roomHeight: window.innerHeight,
  contentHeight: window.innerHeight,
  tilesWidth: 0,
  tilesHeight: 0,
  verticalLayout: false,
  contentWidth: layoutConfig.defaultPinWidth,
  minContentWidth: layoutConfig.minContentWidth,
});

// WARN: Use caution and always use both of these providers simultaneously.
export const { Provider: RoomLayoutValuesProvider } = RoomLayoutValuesContext;
